import React           from 'react';
import PriceMatrix     from 'pu-react/components/PriceMatrix';

export default (props) => {
  const lineItem = props.quote.line_items[0];
  if(lineItem === undefined) return null;

  return (
    <PriceMatrix
      lineItem={lineItem}
      supplier={lineItem.product_key}
      parametersChanged={props.parametersChanged}
      {...props} />
  );
};
